var styles = {"gridPaneContainer":"GridPane-module_gridPaneContainer__nHlwn","gridPaneChild":"GridPane-module_gridPaneChild__-S2Yy","withShadow":"GridPane-module_withShadow__07n22"};

export { styles as default };
//# sourceMappingURL=GridPane.module.scss.js.map
